import { addNotification, notificationStates } from '@components/Notification';
import { paidLeaveOption } from './Leave.constants';

/** Start of local calendar day (for date-only comparisons). */
const startOfLocalDay = (d) => {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
};

/** {year, month, day} → 'YYYY-MM-DD' for LeaveDatePicker, or null if incomplete. */
export const toDateString = (ymd) => {
  if (!ymd || ymd.year == null || ymd.month == null || ymd.day == null) {
    return null;
  }
  const mm = String(ymd.month).padStart(2, '0');
  const dd = String(ymd.day).padStart(2, '0');
  return `${ymd.year}-${mm}-${dd}`;
};

/** 'YYYY-MM-DD' → {year, month, day}, or null if empty/unparseable. */
export const fromDateString = (str) => {
  if (!str) return null;
  const [year, month, day] = str.split('-').map(Number);
  if (!year || !month || !day) return null;
  return { year, month, day };
};

export const validateLeaveForm = (formData) => {
  const { year, month, day } = formData?.leaveDate || {};
  const yi = Number(year);
  const mi = Number(month);
  const di = Number(day);
  if (
    !Number.isFinite(yi) ||
    !Number.isFinite(mi) ||
    !Number.isFinite(di) ||
    di === 0 ||
    mi === 0 ||
    yi === 0
  ) {
    addNotification({
      message: `Invalid Date Please enter valid date !`,
      level: notificationStates.error,
    });
    return false;
  }

  // Check if selected date is in the past (today allowed)
  const selectedDate = startOfLocalDay(new Date(yi, mi - 1, di));
  const today = startOfLocalDay(new Date());

  if (selectedDate < today) {
    addNotification({
      message:
        'Cannot select past dates! Please choose current or future date.',
      level: notificationStates.error,
    });
    return false;
  }

  if (yi < 2023) {
    addNotification({
      message: 'Please choose date after 2023 !',
      level: notificationStates.error,
    });
    return false;
  }
  if (!formData.leaveType?.value) {
    addNotification({
      message: `Please Choose Leave Type`,
      level: notificationStates.error,
    });
    return false;
  }
  if (formData.leaveType?.value === paidLeaveOption.value) {
    if (!formData.paidLeaveType?.value) {
      addNotification({
        message: `Please Choose Paid Leave Type`,
        level: notificationStates.error,
      });
      return false;
    }
  }
  if (!formData.leaveManager?.value) {
    addNotification({
      message: `Please Choose Leave Manager`,
      level: notificationStates.error,
    });
    return false;
  }
  return true;
};
